<agr-page-detail [pageTitle]="pageTitle$ | async" (backAction)="back()">
  <app-animal-group-navigation></app-animal-group-navigation>
  <div class="animal-group-item__container">
    <router-outlet #o="outlet"></router-outlet>
  </div>
</agr-page-detail>
